import { Policy } from "@hagerty/self-service-components/api/types";
import { useFetchApi } from "../../hooks/useFetchApi";

export const usePolicy = (policyNumber: string) => {
  const { data } = useFetchApi<Policy>(`policy/${policyNumber}`, 2);

  return data;
};
